import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { AlertOctagon } from 'lucide-react';
import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import { Checkbox } from '../ui/checkbox';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const PerformanceNoticeCard = () => {
  const [notices, setNotices] = useState([]);
  const [ticked, setTicked] = useState({});
  const headers = { Authorization: `Bearer ${localStorage.getItem('token') || sessionStorage.getItem('token')}` };

  const load = useCallback(async () => {
    try {
      const r = await axios.get(`${API_URL}/api/driver-trips/notices/my`, { headers });
      setNotices((r.data || []).filter((n) => !n.acknowledged_at));
    } catch { /* staff without access simply see nothing */ }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    load();
    window.addEventListener('driver-trips-saved', load);
    return () => window.removeEventListener('driver-trips-saved', load);
  }, [load]);

  const acknowledge = async (id) => {
    try {
      await axios.post(`${API_URL}/api/driver-trips/notices/${id}/acknowledge`, {}, { headers });
      toast.success('Notice acknowledged');
      load();
    } catch (e) { toast.error(e.response?.data?.detail || 'Could not acknowledge'); }
  };

  if (notices.length === 0) return null;

  return notices.map((n) => (
    <Card key={n.id} className="border-2 border-red-600 bg-red-50" data-testid={`performance-notice-${n.id}`}>
      <CardContent className="p-4 space-y-3">
        <div className="flex items-start gap-3">
          <AlertOctagon className="h-6 w-6 text-red-600 shrink-0 mt-0.5" />
          <div className="space-y-1">
            <p className="font-extrabold text-red-700" data-testid="performance-notice-status">Status: {n.title}</p>
            <p className="text-sm text-red-900">{n.message}</p>
            <p className="text-xs text-red-700/80">
              Week {n.week_start} – {n.week_end} · average {n.avg_per_day} parcels/day (grade {n.grade || '—'}) · standard {n.standard}/day
            </p>
          </div>
        </div>
        <div className="flex flex-wrap items-center gap-3 pl-9">
          <label className="flex items-center gap-2 text-sm font-semibold text-red-900 cursor-pointer">
            <Checkbox checked={!!ticked[n.id]} onCheckedChange={(v) => setTicked((p) => ({ ...p, [n.id]: !!v }))} data-testid={`performance-notice-tick-${n.id}`} />
            I have read and understood this notice
          </label>
          <Button size="sm" disabled={!ticked[n.id]} onClick={() => acknowledge(n.id)} className="bg-red-600 hover:bg-red-700" data-testid={`performance-notice-ack-${n.id}`}>
            Acknowledged
          </Button>
        </div>
      </CardContent>
    </Card>
  ));
};
